import watch from 'redux-watch'
import { sendRequest } from '../../lib-alme-request/src/lib-alme-request';

export default class AppeventFeedbackResponse {
    constructor(settings) {
        this._settings = settings;
    }

    getReducer() {
        return (state = {}) => { return state; };
    }

    initialize(store) {
        this._store = store;
        const historyStateLocation = this._settings.stateLocations.History.Base;
        const stagedFeedbackLocation = this._settings.stateLocations.History.capturedStageLocation;
        const stateLocation = `${historyStateLocation}.${stagedFeedbackLocation}`;
        

        const watcher = watch(this._store.getState, stateLocation);

        this._store.subscribe(watcher((newVal, oldVal, objectPath) => {
            newVal = newVal || [];
            if(newVal.length > 0)
                return this.handleStagedFeedback(newVal);
        }));
    }

    handleStagedFeedback(newVal) {
        const eventParams = this._settings.AppEvents.endFeedback.parameters;
        const formId = this._settings.Feedback.formId;
        const endType = this.getEndType(newVal);

        const input = {
            messageType : this._settings.messageConstants.appeventRequest,
            eventName : this._settings.AppEvents.endFeedback.eventName,
            origin : this._settings.originConstants.internal,
            parameters : {
                [eventParams.formId] : formId,
                [eventParams.feedback] : newVal,
                [eventParams.endType] : endType,
            },
        };
        sendRequest(input);
    }

    getEndType(feedback) {
        const endEvent = feedback[feedback.length - 1];
        let endType = this._settings.Feedback.endTypes.aborted;

        if(endEvent.value && endEvent.value.action && endEvent.value.action == this._settings.Analytics.Feedback.actions.completeFeedback) {
            endType = this._settings.Feedback.endTypes.completed;
        }

        return endType;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/appevent-feedback-response/src/appevent-feedback-response.js